export enum ComponentEnum {
    Home = 'HomeComponent',
    SingleProduct = 'SingleProductComponent',
    MenuItem = 'MenuItemComponent',
    Checkout = 'CheckoutComponent',
    Summary = 'SummaryComponent',
    CreditCardForm = 'CreditCardFormComponent',
    DeliveryData = 'DeliveryDataComponent',
    Auth = 'AuthComponent',
    ResetPassword = 'ResetPasswordComponent',
    MyProfile = 'MyProfileComponent',
    MyAddressForm = 'MyAddressFormComponent',
    CheckoutHeader = 'CheckoutHeaderComponent',
    TipPromo = 'TipPromoComponent',
    UserInfoForm = 'UserInfoFormComponent',
    MultiStore = 'MultiStoreComponent',
    Card = 'CardComponent',
    CartItems = 'CartItemsComponent',
    Loading = 'LoadingComponent',
    Switch = 'SwitchComponent',
    App = 'AppComponent',
    ShoppingCart = 'ShoppingCartComponent',
    NotFound = 'NotFoundComponent',
    Soon = 'SoonComponent',
    Notification = 'NotificationComponent',
    TermsConditions = 'TermsConditionsComponent',
    Dialog = 'DialogComponent',
}

export type ComponenteEnumValues = `$${ComponentEnum}`;